<template>
  <div class="additional-setup-rv3434">
    <div class="additional-setup-rv3434__header">
      <v-icon color="primary" class="additional-setup-rv3434__header-icon">mdi-tune-variant</v-icon>
      <h2 class="additional-setup-rv3434__title">Дополнительные настройки</h2>
    </div>
    <v-row>
      <v-col cols="12" md="6" class="pb-0">
        <v-row>
          <v-col v-if="$checkPermission('upload_ring_sound_doorphone')" cols="12" md="9" class="py-0">
              <v-file-input
                ref="soundBeep"
                v-model='formOptionalSettings.soundBeep'
                accept=".wav"
                outlined
                dense
                flat
                label="Установление рингтона (звук гудка)"
                :rules='rules.sound'
                append-icon="mdi-information-outline"
                @click:append="infoSoundBeep = !infoSoundBeep"
              ></v-file-input>
              <v-col
                v-if="infoSoundBeep"
                class="ml-5 pt-0"
              >
                <p>Формат файла: wav. Размер: до 200 КБ.</p>
                <p>Частота дискретизации: 16000 Гц. Бит: 16</p>
              </v-col>
            </v-col>
            <v-col v-if="$checkPermission('upload_ring_sound_doorphone')" cols="12" md="3" class="py-0">
              <v-btn color="primary" class="text-none" dark rounded @click="changeSoundBeep()">
                <v-icon left small>mdi-upload</v-icon>
                Загрузить
              </v-btn>
            </v-col>
            <v-col v-if="$checkPermission('upload_open_door_sound_doorphone')" cols="12" md="9" class="py-0">
              <v-file-input
                ref="soundDoor"
                v-model='formOptionalSettings.soundDoorOpening'
                accept=".wav"
                outlined
                dense
                flat
                label="Установление аудизаписи (звук открытия двери)"
                :rules='rules.sound'
                append-icon="mdi-information-outline"
                @click:append="infoSoundDoor = !infoSoundDoor"
              ></v-file-input>
              <v-col
                v-if="infoSoundDoor"
                class="ml-5 pt-0"
              >
                <p>Формат файла: wav. Размер: до 200 КБ.</p>
                <p>Частота дискретизации: 16000 Гц. Бит: 16</p>
              </v-col>
            </v-col>
            <v-col v-if="$checkPermission('upload_open_door_sound_doorphone')" cols="12" md="3" class="py-0">
              <v-btn color="primary" class="text-none" dark rounded @click="changeSoundDoor()">
                <v-icon left small>mdi-upload</v-icon>
                Загрузить
              </v-btn>
            </v-col>
            <v-col v-if="$checkPermission('upload_error_sound_doorphone')" cols="12" md="9" class="py-0">
                <v-file-input
                ref="soundError"
                v-model='formOptionalSettings.soundError'
                accept=".wav"
                outlined
                dense
                flat
                label="Звуковое уведомление об ошибке"
                :rules='rules.sound'
                append-icon="mdi-information-outline"
                @click:append="infoSoundError = !infoSoundError"
                ></v-file-input>
              <v-col v-if="infoSoundError" class="ml-5 pt-0">
                <p class="rules-input">Формат файла: wav. Размер: до 200 КБ.</p>
                <p class="rules-input">Частота дискретизации: 16000 Гц. Бит: 16</p>
              </v-col>
            </v-col>
            <v-col v-if="$checkPermission('upload_error_sound_doorphone')" cols="12" md="3" class="py-0">
                <v-btn color="primary" class="text-none" dark rounded @click="changeSoundError()">
                  <v-icon left small>mdi-upload</v-icon>
                  Загрузить
                </v-btn>
            </v-col>
              <v-col v-if="$checkPermission('upload_keypress_sound_doorphone')" cols="12" md="9" class="py-0">
                <v-file-input
                  ref="soundKeypress"
                  v-model='formOptionalSettings.soundKeypress'
                  accept=".wav"
                  outlined
                  dense
                  flat
                  label="Звуковое уведомление о нажатии на клавиш"
                  :rules='rules.sound'
                  append-icon="mdi-information-outline"
                  @click:append="infoSoundKeypress = !infoSoundKeypress"
                ></v-file-input>
                <v-col v-if="infoSoundKeypress" class="ml-5 pt-0">
                  <p class="rules-input">Формат файла: wav. Размер: до 200 КБ.</p>
                  <p class="rules-input">Частота дискретизации: 16000 Гц. Бит: 16</p>
                </v-col>
              </v-col>
              <v-col v-if="$checkPermission('upload_keypress_sound_doorphone')" cols="12" md="3" class="py-0">
                <v-btn color="primary" class="text-none" dark rounded @click="changeSoundKeypress()">
                  <v-icon left small>mdi-upload</v-icon>
                  Загрузить
                </v-btn>
              </v-col>
              <v-col v-if="$checkPermission('upload_custom_sound_doorphone')" cols="12" md="9" class="py-0">
                <v-file-input
                  ref="soundCustom"
                  v-model='formOptionalSettings.soundCustom'
                  accept=".wav"
                  outlined
                  dense
                  flat
                  label="Звуковое уведомление для пользовательского режима"
                  :rules='rules.sound'
                  append-icon="mdi-information-outline"
                  @click:append="infoSoundCustom = !infoSoundCustom"
                ></v-file-input>
                <v-col v-if="infoSoundCustom" class="ml-5 pt-0">
                  <p class="rules-input">Формат файла: wav. Размер: до 200 КБ.</p>
                  <p class="rules-input">Частота дискретизации: 16000 Гц. Бит: 16</p>
                </v-col>
              </v-col>
              <v-col v-if="$checkPermission('upload_custom_sound_doorphone')" cols="12" md="3" class="py-0">
                <v-btn color="primary" class="text-none" dark rounded @click="changeSoundCustom()">
                  <v-icon left small>mdi-upload</v-icon>
                  Загрузить
                </v-btn>
              </v-col>
            <v-col v-if="$checkPermission('upload_emergency_sound_doorphone')" cols="12" md="9" class="py-0">
                <v-file-input
                ref="soundEmergency"
                v-model='formOptionalSettings.soundEmergency'
                accept=".wav"
                outlined
                dense
                flat
                label="Звуковое уведомление о чрезвычайной ситуации"
                :rules='rules.sound'
                append-icon="mdi-information-outline"
                @click:append="infoSoundEmergency = !infoSoundEmergency"
                ></v-file-input>
              <v-col v-if="infoSoundEmergency" class="ml-5 pt-0">
                <p class="rules-input">Формат файла: wav. Размер: до 200 КБ.</p>
                <p class="rules-input">Частота дискретизации: 16000 Гц. Бит: 16</p>
              </v-col>
            </v-col>
            <v-col v-if="$checkPermission('upload_emergency_sound_doorphone')" cols="12" md="3" class="py-0">
                <v-btn color="primary" class="text-none" dark rounded @click="changeSoundEmergency()">
                  <v-icon left small>mdi-upload</v-icon>
                  Загрузить
                </v-btn>
            </v-col>
              <v-col v-if="$checkPermission('import_from_csv_keys_doorphone')" cols="12" md="9" class="py-0">
                <v-file-input
                  ref="KeysDoorphone"
                  v-model='formOptionalSettings.keysUpload'
                  accept=".csv"
                  outlined
                  dense
                  flat
                  label="Ключи"
                  :rules='rules.keys'
                  append-icon="mdi-information-outline"
                  @click:append="infoKeysUpload = !infoKeysUpload"
                ></v-file-input>
                <v-col
                  v-if="infoKeysUpload"
                  class="ml-5 pt-0"
                >
                  <p>Формат файла: csv</p>
                </v-col>
              </v-col>
              <v-col v-if="$checkPermission('import_from_csv_keys_doorphone')" cols="12" md="3" class="py-0">
                <v-btn color="primary" class="text-none" dark rounded @click="importKeys()">
                  <v-icon left small>mdi-upload</v-icon>
                  Загрузить
                </v-btn>
              </v-col>
              <v-col v-if="$checkPermission('update_operating_mode_doorphone')" cols="8" sm="5" md="5" lg="5" class="py-0 mb-1 ml-2">
                <v-checkbox
                  v-model="formOptionalSettings.customMode"
                  :disabled="formOptionalSettings.emergencyMode"
                  label="Пользовательский режим"
                  hide-details
                  dense
                  color="success"
                  @change="handleModeChange('customMode')"
                />
              </v-col>
              <v-col v-if="$checkPermission('update_operating_mode_doorphone')" cols="8" sm="5" md="5" lg="5" class="py-0">
                <v-checkbox
                  v-model="formOptionalSettings.emergencyMode"
                  :disabled="formOptionalSettings.customMode"
                  label="Режим чрезвычайной ситуации"
                  hide-details
                  dense
                  color="success"
                  @change="handleModeChange('emergencyMode')"
                />
              </v-col>
              <v-col class="ml-4 pt-2">
                <p>Одновременное включение обоих режимов невозможно.</p>
              </v-col>
            </v-row>
        </v-col>

      <v-dialog v-model="dialogError" max-width="550" content-class="dialog-border-radius">
        <v-card>
          <v-card-title class="headline">Ошибки при загрузке ключей</v-card-title>
          <v-card-text>
            <ul v-if="errorMessages.length">
              <li v-for="(error, index) in errorMessages" :key="index">
                {{ error }}
              </li>
            </ul>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" outlined rounded class="text-none" @click="dialogError = false">
              Закрыть
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { rules } from '../../../consts';
import doorphone from '@/services/api/doorphone';

export default {
  name: 'AdditionalSetupRV3434',
  data: () => ({
    infoSoundError: false,
    infoSoundKeypress: false,
    infoSoundCustom: false,
    infoSoundEmergency: false,
    infoKeysUpload: false,
    infoSoundBeep: false,
    infoSoundDoor: false,
    dialogError: false,
    rules,
    errorMessages: [],
    formOptionalSettings: {
      soundError: null,
      soundKeypress: null,
      soundCustom: null,
      keysUpload: null,
      soundEmergency: null,
      soundBeep: null,
      soundDoorOpening: null,
      emergencyMode: false,
      customMode: false,
    },
  }),
  created () {
    if (this.$checkPermission('get_custom_mode_doorphone')) {
      this.getCustomMode({ id: this.$route.params.id })
        .then((data) => {
          const modeSettings = {
            0: { emergencyMode: false, customMode: false },
            1: { emergencyMode: false, customMode: true },
            2: { emergencyMode: true, customMode: false },
          };

          const settings = modeSettings[data.data.is_enabled_mode] || { emergencyMode: false, customMode: false };

          this.formOptionalSettings.emergencyMode = settings.emergencyMode;
          this.formOptionalSettings.customMode = settings.customMode;
        })
        .catch((err) => {
          console.error(err);
          this.$flash_warning('Ошибка, не удалось получить режим работы домофона');
        })
        .finally(() => {
        });
    }
  },
  computed: {
    ...mapGetters({
      doorphone: 'Doorphone/doorphoneEditDoorphone',
      doorphoneEditInfo: 'Doorphone/doorphoneEditInfo',
    }),
    displayDuplicate () {
      return (this.doorphoneEditInfo.doorphone.type === 'M') && ((this.doorphoneEditInfo.doorphone.additionalEntrances.length > 0) ||
        (this.doorphoneEditInfo.doorphone.gates.length > 0));
    },
    control () {
      const d = this.doorphoneEditInfo && this.doorphoneEditInfo.doorphone;
      return d && d.manufacturer === 'Rubetek';
    },
  },
  methods: {
    ...mapActions({
      uploadRingsound: 'Doorphone/uploadRingsound',
      getCustomMode: 'Doorphone/getCustomMode',
      setCustomMode: 'Doorphone/setCustomMode',
      uploadDoorsound: 'Doorphone/uploadDoorsound',
      uploadCustomSound: 'Doorphone/uploadCustomSound',
      uploadKeypressSound: 'Doorphone/uploadKeypressSound',
      uploadErrorSound: 'Doorphone/uploadErrorSound',
      uploadEmergencySound: 'Doorphone/uploadEmergencySound',
    }),
    changeSoundBeep () {
      if (this.$refs.soundBeep.validate()) {
        const formData = new FormData();
        formData.append('sound', this.formOptionalSettings.soundBeep);

        this.uploadRingsound({ id: this.doorphoneEditInfo.doorphone.id, formData })
          .then(() => {
            this.formOptionalSettings.soundBeep = null;
            this.$flash_success('Изменения успешно сохранены');
            this.$refs.soundBeep.resetValidation();
          })
          .catch(() => {
            this.$flash_warning('Ошибка при смене звука гудка');
          });
      } else {
        this.$flash_warning('Заполните поле');
      }
    },
    async handleModeChange (mode) {
      if (mode === 'customMode' && this.formOptionalSettings.customMode) {
        this.formOptionalSettings.emergencyMode = false;
      } else if (mode === 'emergencyMode' && this.formOptionalSettings.emergencyMode) {
        this.formOptionalSettings.customMode = false;
      }

      await this.changeMode();
    },
    changeMode () {
      const enabledMode = this.formOptionalSettings.customMode ? 1 : this.formOptionalSettings.emergencyMode ? 2 : 0;

      this.setCustomMode({ id: this.doorphoneEditInfo.doorphone.id, isEnabledMode: enabledMode })
        .then(() => {
          this.$flash_success('Изменения успешно сохранены');
        })
        .catch(() => {
          this.$flash_warning('Ошибка при изменении режима работы домофона.');
        });
    },
    changeSoundDoor () {
      if (this.$refs.soundDoor.validate()) {
        const formData = new FormData();
        formData.append('sound', this.formOptionalSettings.soundDoorOpening);

        this.uploadDoorsound({ id: this.doorphoneEditInfo.doorphone.id, formData })
          .then(() => {
            this.formOptionalSettings.soundDoorOpening = null;
            this.$flash_success('Изменения успешно сохранены');
            this.$refs.soundDoor.resetValidation();
          })
          .catch(() => {
            this.$flash_warning('Ошибка при смене звука открытия двери');
          });
      } else {
        this.$flash_warning('Заполните поле');
      }
    },
    changeSoundError () {
      if (this.$refs.soundError.validate()) {
        const formData = new FormData();
        formData.append('sound', this.formOptionalSettings.soundError);

        this.uploadErrorSound({ id: this.doorphoneEditInfo.doorphone.id, formData })
          .then(() => {
            this.formOptionalSettings.soundError = null;
            this.$flash_success('Изменения успешно сохранены');
            this.$refs.soundError.resetValidation();
          })
          .catch(() => {
            this.$flash_warning('Ошибка при смене звука уведомления об ошибке');
          });
      } else {
        this.$flash_warning('Заполните поле');
      }
    },
    changeSoundKeypress () {
      if (this.$refs.soundKeypress.validate()) {
        const formData = new FormData();
        formData.append('sound', this.formOptionalSettings.soundKeypress);

        this.uploadKeypressSound({ id: this.doorphoneEditInfo.doorphone.id, formData })
          .then(() => {
            this.formOptionalSettings.soundKeypress = null;
            this.$flash_success('Изменения успешно сохранены');
            this.$refs.soundKeypress.resetValidation();
          })
          .catch(() => {
            this.$flash_warning('Ошибка при смене звука уведомления о нажатии клавиши');
          });
      } else {
        this.$flash_warning('Заполните поле');
      }
    },
    changeSoundCustom () {
      if (this.$refs.soundCustom.validate()) {
        const formData = new FormData();
        formData.append('sound', this.formOptionalSettings.soundCustom);

        this.uploadCustomSound({ id: this.doorphoneEditInfo.doorphone.id, formData })
          .then(() => {
            this.formOptionalSettings.soundCustom = null;
            this.$flash_success('Изменения успешно сохранены');
            this.$refs.soundCustom.resetValidation();
          })
          .catch(() => {
            this.$flash_warning('Ошибка при смене звука уведомления для пользовательского режима');
          });
      } else {
        this.$flash_warning('Заполните поле');
      }
    },
    importKeys () {
      if (this.$refs.KeysDoorphone.validate()) {
        const formData = new FormData();
        formData.append('keys', this.formOptionalSettings.keysUpload);
        doorphone.uploadKeys(this.doorphoneEditInfo.doorphone.id, formData)
          .then(response => {
            if (response.data.errors && response.data.errors.length > 0) {
              this.errorMessages = response.data.errors;
              this.dialogError = true;
            } else {
              this.formOptionalSettings.keysUpload = null;
              this.$flash_success('Изменения успешно сохранены');
              this.$refs.KeysDoorphone.resetValidation();
            }
          })
          .catch(() => {
            this.$flash_warning('Ошибка при загрузке ключей');
          });
      } else {
        this.$flash_warning('Заполните поле');
      }
    },
    changeSoundEmergency () {
      if (this.$refs.soundEmergency.validate()) {
        const formData = new FormData();
        formData.append('sound', this.formOptionalSettings.soundEmergency);

        this.uploadEmergencySound({ id: this.doorphoneEditInfo.doorphone.id, formData })
          .then(() => {
            this.formOptionalSettings.soundEmergency = null;
            this.$flash_success('Изменения успешно сохранены');
            this.$refs.soundEmergency.resetValidation();
          })
          .catch(() => {
            this.$flash_warning('Ошибка при смене звука уведомления о чрезвычайной ситуации');
          });
      } else {
        this.$flash_warning('Заполните поле');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.additional-setup-rv3434__header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.additional-setup-rv3434__header-icon {
  flex-shrink: 0;
}

.additional-setup-rv3434__title {
  font-size: 1.25rem;
  font-weight: 500;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.01em;
}

.rules-input {
  margin-bottom: 7px;
}
</style>
